import React, { useEffect } from 'react';
const FONT_HREF = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,500;0,9..144,600;1,9..144,500;1,9..144,600&family=Inter:wght@400;500;600;700&display=swap';
const MARKER = 'data-font-preload';

/**
 * Loads Fraunces + Inter without blocking first render: preconnect, preload the
 * stylesheet, then swap the non-blocking print stylesheet to all once it lands.
 */
export function FontPreload() {
  useEffect(() => {
    if (document.head.querySelector(`[${MARKER}]`)) return;
    const created: HTMLLinkElement[] = [];
    const add = (attrs: Record<string, string>) => {
      const link = document.createElement('link');
      link.setAttribute(MARKER, '');
      Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value));
      document.head.appendChild(link);
      created.push(link);
      return link;
    };
    add({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    add({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    add({
      rel: 'preload',
      as: 'style',
      href: FONT_HREF
    });
    const sheet = add({
      rel: 'stylesheet',
      href: FONT_HREF,
      media: 'print'
    });
    const activate = () => {
      sheet.media = 'all';
    };
    sheet.addEventListener('load', activate);
    return () => {
      sheet.removeEventListener('load', activate);
    };
  }, []);
  return null;
}